import { defineQuery } from 'groq';

export const topLevelCategoriesQuery = defineQuery(`
*[_type == "category"
    && mgApp == "mgpris"
    && !(_id in *[_type == "category"].subCategories[]._ref)
    && $language in i18nTitles[]._key
    && $consumer in publishToGroups[]->value
  ] {
  "title": i18nTitles[_key == $language][0].value,
  "slug": slug.current,
  "id": _id,
}
`);

export const subCategoriesQuery = defineQuery(`
array::compact(
  *[_type == "category" && mgApp == "mgpris" && _id == $categoryId].subCategories[]-> {
    "title": i18nTitles[_key == $language][0].value,
    "slug": slug.current,
    "id": _id,
    "publishTo": publishToGroups[]->value
  }
)
`);

export const categoryArticlesQuery = defineQuery(`
  *[_type == "article" && $categoryId in categories[]._ref && language == $language && $consumer in publishToGroups[]->value]{
    title,
    "slug": slug.current,
  }
`);

export const helpArticleQuery = `
*[_type == "article"][language == $language][slug.current == $slug][0] {
    title,
    content[] {
      ...,
      markDefs[]{
        ...,
        _type == "concept" => {
          "reference": reference->{
            title,
            definition
          }
        }
      }
    }
  }
`;

export const articleSearchQuery = defineQuery(`
  *[_type == "article" && language == $language && $consumer in publishToGroups[]->value &&
    (pt::text(content) match $searchText + "*" || title match $searchText + "*")
  ]
  | score(pt::text(content) match $searchText + "*", boost(title match $searchText + "*", 2))
  [0..9]
  {
    title,
    "slug": slug.current
  }
`);
